import React, { useState, useEffect, useRef } from 'react';
import { Typography } from '@mui/material';
import { motion } from 'framer-motion';

const AnimatedCounter = ({ 
  value, 
  duration = 1000, 
  prefix = '', 
  suffix = '',
  formattingFn = (val) => val,
  ...props 
}) => {
  const [displayValue, setDisplayValue] = useState(0);
  const prevValue = useRef(value);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => { isMounted.current = false; };
  }, []);

  useEffect(() => {
    if (value !== prevValue.current) {
      const start = prevValue.current;
      const end = value;
      const startTime = performance.now();
      
      const animate = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const currentValue = start + (end - start) * progress;
        
        if (isMounted.current) {
          setDisplayValue(currentValue);
        }

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          prevValue.current = value;
        }
      };

      requestAnimationFrame(animate);
    }
  }, [value, duration]);

  return (
    <motion.span {...props}>
      {prefix}
      {formattingFn(Math.floor(displayValue))}
      {suffix}
    </motion.span>
  );
};

export default AnimatedCounter;